
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import MenuItem from '@/model/menuItem'

@Component
export default class MenuDrawerItem extends Vue {
  @Prop({ required: true })
  public item !: MenuItem

  public get isHomePage (): boolean {
    return this.item.link === '/' && this.$route.name === 'Home'
  }
}
